<template>
    <div>
      <span @click="closebox">
        <svg style="width:20px;height:20px" viewBox="0 0 24 24">
          <path fill="currentColor" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
        </svg>
      </span>
      <strong>{{ name }}</strong>
    </div>
</template>
<style scoped>
span {
  cursor: pointer;
}
strong {
  margin-left: 12px;
  margin-top: 3px;
}
</style>
<script>
export default {
  props: {
    name: String
  },
  methods: {
    closebox () {
      this.$parent.closebox()
    }
  }
}
</script>